import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import moment from "moment";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const inOutBookList = createAsyncThunk('inOutBook/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `inout_log`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'type_id': data?.type_id,
                'sub_type_id': data?.sub_type_id,
                'created_at': data?.created_at || (data?.date && moment(data?.date, 'DD/MM/YYYY').format('YYYY-MM-DD')),
                'fDate': data?.fDate || undefined,
                'tDate': data?.tDate || undefined,
                'status': data?.status,
                'user_type': data?.user_type,
                'premise_id': data?.premise_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const inOutBookDetails = createAsyncThunk('inOutBook/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `inout_log/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const vehicleDetail = createAsyncThunk('inOutBook/vehicleDetail', async ({ vehicle_number }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'vehicle_detail',
            data: {
                vehicle_number: vehicle_number,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const ticketByGuard = createAsyncThunk('inOutBook/ticketByGuard', async (data) => {
    const bodyFormData = new FormData()

    bodyFormData.append('premise_id', data?.premise_id ?? '')
    bodyFormData.append('user_info', JSON.stringify(data?.user_info ?? []))
    bodyFormData.append('vehicle_number', data?.vehicle_number ?? '')
    bodyFormData.append('vehicle_type', data?.vehicle_type ?? '')

    if (data?.ticket_file && Array.isArray(data.ticket_file)) {
        data.ticket_file.forEach((file) => {
            bodyFormData.append('ticket_file', file)
        })
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'ticket_by_guard',
            data: bodyFormData,
            headers: {
                'Content-Type': 'multipart/form-data', 'type': 'ticket_file', 'Authorization': SessionManager.getCookie('user_token'),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const inOutEntries = createAsyncThunk('inOutBook/entries', async (data) => {

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'inout_log',
            data: {
                premise_id: data?.values?.premise_id,
                gate_id: data?.values?.gate_id,
                user_type: data?.values?.entry_type,
                user_name: data?.values?.visitor_name || data?.values?.delivery_person_name,
                user_mobile: data?.values?.mobile_number,
                type_id: data?.values?.type_id || data?.values?.type,
                sub_type_id: data?.values?.sub_type,
                user_id: data?.values?.delivery_partner,
                unit_id: data?.values?.unit_id ?? data?.values?.unit,
                drop_at: data?.values?.drop_at,
                description: data?.values?.purpose,
                parking_id: data?.values?.parking_id,
                vehicle_type: data?.values?.vehicle_type,
                user_vehicle: data?.values?.vehicle_number,
                day: data?.values?.days,
                hours: data?.values?.hours,
                user_profile: data?.values?.photo_capture,
                id_proof: data?.values?.id_proof,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const serviceProviderQuickInEntry = createAsyncThunk('inOutBook/serviceProviderQuickInEntry', async ({ values }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'inout_log',
            data: {
                premise_id: values?.premise_id,
                gate_id: values?.gate_id && parseInt(values?.gate_id),
                user_type: values?.entry_type,
                user_id: values?.sp_id,
                parking_id: values?.parking_id,
                vehicle_type: values?.vehicle_type,
                user_vehicle: values?.vehicle_number,
                day: values?.days,
                hours: values?.hours,
                user_profile: values?.photo_capture,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const residentEntry = createAsyncThunk('inOutBook/residentEntry', async ({ values }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'inout_log',
            data: {
                premise_id: values?.premise_id,
                gate_id: values?.gate_id,
                user_type: values?.entry_type,
                user_id: values?.resident_id,
                user_mobile: values?.mobile_number,
                unit_id: values?.unit,
                user_vehicle: values?.vehicle_number,
                user_profile: values?.photo_capture,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const scanInOutEntry = createAsyncThunk('inOutBook/scanInOutEntry', async ({ values }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'inout_log',
            data: {
                premise_id: values?.premise_id,
                role_id: values?.role_id && parseInt(values?.role_id),
                gate_id: values?.gate_id && parseInt(values?.gate_id),
                user_type: values?.userType,
                visitor_id: values?.user_id,
                parking_id: values?.parking_id,
                vehicle_type: values?.vehicle_type,
                user_vehicle: values?.vehicle_number,
                user_profile: values?.photo_capture,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const visitorQrScanner = createAsyncThunk('inOutBook/visitorQrScanner', async ({ qr_code }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'visitor_qr_scanner',
            data: {
                qr_code: qr_code,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const outEntry = createAsyncThunk('inOutBook/outEntry', async ({ values }) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'update_inout_log',
            data: {
                inout_id: values?.id,
                gate_id: values?.gate_id && parseInt(values?.gate_id),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const resendInOutRequest = createAsyncThunk('inOutBook/resendRequest', async ({ values }) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'resend_visitor_request',
            data: {
                inout_id: values?.id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const inOutBook = createSlice({
    name: 'inOutBook',
    initialState: {
        list: [],
        details: null,
        loading: false,
        vehicleDetails: null,
        vehicleDetailsLoading: false,
    },
    reducers: {
        clearVehicleDetails: (state) => {
            state.vehicleDetails = null
            state.vehicleDetailsLoading = false
        },
    },
    extraReducers: (builder) => {
        builder.addCase(inOutBookList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        });

        builder.addCase(inOutBookDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });

        builder.addCase(vehicleDetail.pending, (state) => {
            state.vehicleDetailsLoading = true
        });
        builder.addCase(vehicleDetail.fulfilled, (state, action) => {
            state.vehicleDetailsLoading = false
            if (action?.payload?.status === 200) {
                state.vehicleDetails = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.vehicleDetails = null
            }
        });
        builder.addCase(vehicleDetail.rejected, (state) => {
            state.vehicleDetailsLoading = false
        });
    }
})

export const { clearVehicleDetails } = inOutBook.actions;
export default inOutBook.reducer;